	export enum PureToneDegreeEnum {
		Normal = 1,
		Slight = 2,
		Mild = 3,
		Moderate = 4,
		Severe = 5,
		Profound = 6
	}
